module.exports = __webpack_public_path__ + "static/media/19ESCAP47.49a1b562.jpg";